import { render, staticRenderFns } from "./EditRuleModal.vue?vue&type=template&id=f8159816&scoped=true"
import script from "./EditRuleModal.vue?vue&type=script&lang=js"
export * from "./EditRuleModal.vue?vue&type=script&lang=js"
import style0 from "./EditRuleModal.vue?vue&type=style&index=0&id=f8159816&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8159816",
  null
  
)

export default component.exports